export default {
  title: 'Pagar com Pix',
  hint: 'Copie o código e cole-o no Pix na sua app do banco, ou digitalize o código QR com ele.',
  copy: 'Copiar código Pix',
  copied: 'Código copiado',
  qr_alt: 'Código QR Pix',
  expires_in: 'O código expira em {{time}}',
  waiting: 'Confirmaremos a sua encomenda assim que o seu banco enviar o pagamento.',
  open_page: 'Abrir a página de pagamento',
  expired: 'Este código Pix expirou. Inicie o pagamento novamente para obter um novo.',
  cancel: 'Cancelar pagamento',
  checking: 'A verificar o seu pagamento…',
  close: 'Fechar',
};
